import { render, staticRenderFns } from "./AccordionPage.vue?vue&type=template&id=f9bb3024&"
import script from "./AccordionPage.vue?vue&type=script&lang=ts&"
export * from "./AccordionPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports